import React from "react";

import Buttons from "./buttons";
import { useForm } from "./hooks";

export default function Form({
  submitUrl,
  action,
  cancelUrl,
  success = false,
  successMessage,
  errors,
  children,
  saveValue,
  cancelText,
  style={},
  onSuccess = null
}) {
  const { onSubmit, isSubmitting } = useForm(submitUrl, action, onSuccess);
  if (success) {
    return successMessage;
  }
  return (
    <form style={style} onSubmit={onSubmit}>
      {children}
      <Buttons
        isSubmitting={isSubmitting}
        cancelUrl={cancelUrl}
        saveValue={saveValue}
        cancelText={cancelText}
      />
    </form>
  );
}
